'use client';
import { Tab } from '@headlessui/react';
import Typography from 'components/Typography';
import { FC, HTMLAttributes, PropsWithChildren, ReactNode, useState } from 'react';
import { cn } from 'utils/cn';

interface IWizard extends PropsWithChildren<HTMLAttributes<HTMLElement>> {
  tabs: {
    label: string;
    content?: string;
    icon?: ReactNode;
    clipart?: ReactNode;
  }[];
}
[];

const Wizard: FC<IWizard> = ({ tabs, ...rest }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
      <div className="relative flex justify-between">
        <div className={cn('flex w-full justify-start pr-8', 'lg:w-1/2')}>
          <Tab.List className={cn('mb-0 flex flex-col')}>
            {tabs.map(({ label, icon, content }, index) => (
              <Tab className={cn('focus:outline-none active:outline-none')} key={index} {...rest}>
                {({ selected }) => (
                  <div
                    className={cn(
                      'flex flex-col',
                      'mb-0 py-2 pb-4 pl-4 focus:outline-none active:outline-none',
                      'min-w-fit transition-colors duration-500 ease-in-out',
                      'cursor-pointer border-0 border-l-[3px] border-transparent',
                      selected ? 'border-l-primary-green-100 ' : 'border-l-tolq-gray-100'
                    )}
                  >
                    <div className="flex flex-col">
                      <Typography
                        className={cn(
                          selected ? `!text-tolq-green-100 ` : '!text-tolq-gray-100  ',
                          'flex gap-4 text-left'
                        )}
                      >
                        {icon}
                        {label}
                      </Typography>
                      <Typography
                        className={cn(
                          ' pl-12 text-left text-tolq-black-200 transition-all duration-1000 ease-in',
                          selected ? '!h-20 text-lg opacity-100' : 'h-0 text-sm opacity-0'
                        )}
                        variant={'regular2'}
                      >
                        {content}
                      </Typography>
                    </div>
                  </div>
                )}
              </Tab>
            ))}
          </Tab.List>
        </div>
        <div className="hidden w-1/2 justify-end lg:flex">
          <div className="relative w-4/5">
            <Tab.Panels>
              {tabs.map(({ clipart }, index) => (
                <Tab.Panel className={cn('focus:outline-none active:outline-none')} key={index}>
                  {clipart}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </div>
        </div>
      </div>
    </Tab.Group>
  );
};

export default Wizard;
